import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const likeApi = {
  check (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/likes/check/`, {params: params})
  },
  create (params) {
    // 创建新赞
    return axios.post(`${ApiSetting.baseUrl}/api/likes/`, querystring.stringify(params))
  },
  remove (likeId) {
    // 创建新赞
    return axios.delete(`${ApiSetting.baseUrl}/api/likes/${likeId}/`)
  },
}

export default likeApi
